import type { It4Response } from "@/shared/api";

import { stagePost } from "@/shared/api";

export interface DeviceBrand {
    brand_id: string;
    name: string;
}

export interface DeviceCategory {
    category_id: string;
    name: string;
}

export interface DeviceBrandCategory {
    brand_id: string;
    category_id: string;
}

/** Справочник брендов и категорий */
export interface DeviceDeps {
    brands: DeviceBrand[];
    brands_categories: DeviceBrandCategory[];
    categories: DeviceCategory[];
}

/** Получить бренды и категории */
export async function getDeviceDeps(payload: { token: string }): Promise<DeviceDeps> {
    const response = await stagePost<It4Response<DeviceDeps>>(
        `/api/tin/v1/site/quest/calc/deps/?token=${encodeURIComponent(payload.token)}`,
        payload,
    );
    return response.data;
}
